import React from 'react';
import { connect } from 'react-redux';

import WaitingAreaCallerEntryPointPage from './WaitingAreaCallerEntryPointPage.js';
import WaitingAreaGeneralDetailPage from './WaitingAreaFormPage.js';
import WaitingAreaOperatingHoursPage from './WaitingAreaOperatingHoursPage.js';
import WaitingAreaLocalAccessHoursPage from './WaitingAreaLocalAccessHoursPage.js';
import WaitingAreaBeforeCallsPage from './WaitingAreaBeforeCallsPage.js';
import WaitingAreaBeforeCallsImportantInfoPage from './WaitingAreaBeforeCallsImportantInfoPage.js';
import WaitingAreaAfterCallsPage from './WaitingAreaAfterCallsPage.js';
import WaitingAreaLogoPauseImage from './WaitingAreaLogoPauseImage.js';
import WaitingAreaDeleteWAModal from '../components/pages/waiting-area/delete-wa/content.js';
import SuspendWAPage from '../components/pages/waiting-area/suspend/content.js';
import WaitingAreaDuringCallsPage from './WaitingAreaDuringCallsPage';
import SupportContactModal from './SupportContactModal';
import InfoForCallersModal from './WaitingAreaInfoForCallersModal';
import WAShareLinkMessageModalContainer from '../components/pages/waiting-area/share-link-message/content.js';
import ConsultNowSettingPage from './ConsultNowSettingPage.js';
import WAAudioSettingPage from './WAAudioSettingPage.js';
import objectAssign from 'object-assign';
import GroupConsultationSettingsPage from './GroupConsultationSettingsPage';

export const WaitingAreasAdminModals = (props) => {
  let modals = '';
  let viewableGCModals = '';
  if (props.waitingArea && props.waitingArea.permissions && props.waitingArea.permissions.length > 0) {
    let hasEditWaitingAreaAccess = props.waitingArea.permissions.indexOf('EDIT') > -1;
    let hasViewWaitingAreaAccess = props.waitingArea.permissions.indexOf('VIEW') > -1;
    let hasOrgEditAccess = props.waitingArea.permissions.indexOf('ORGANISATION_EDIT') > -1;
    let hasOrgUnitManageUsersAccess =
      props.orgUnit &&
      props.orgUnit.permissions &&
      props.orgUnit.permissions.indexOf(APP.LANGUAGE.Org_Permission.MANAGE_USERS) > -1;

    if (hasEditWaitingAreaAccess && hasViewWaitingAreaAccess) {
      modals = (
        <div>
          {props.showBeforeCallsModal == true ? (
            <WaitingAreaBeforeCallsPage waitingArea={props.waitingArea} updateOrView="update" />
          ) : (
            ''
          )}
          {props.showBeforeCallsImportantInfoModal == true ? (
            <WaitingAreaBeforeCallsImportantInfoPage waitingArea={props.waitingArea} updateOrView="update" />
          ) : (
            ''
          )}
          {props.showAfterCallsModal == true ? (
            <WaitingAreaAfterCallsPage waitingArea={props.waitingArea} updateOrView="update" />
          ) : (
            ''
          )}
          {props.showCallerEntryModal == true ? (
            <WaitingAreaCallerEntryPointPage waitingArea={props.waitingArea} updateOrView="update" />
          ) : (
            ''
          )}
          {props.showDuringCallsModal == true ? (
            <WaitingAreaDuringCallsPage waitingArea={props.waitingArea} updateOrView="update" />
          ) : (
            ''
          )}
          {props.showInfoForCallersModal == true ? (
            <InfoForCallersModal waitingArea={props.waitingArea} updateOrView="update" />
          ) : (
            ''
          )}
          {props.showWAShareLinkMessageModal == true ? (
            <WAShareLinkMessageModalContainer waitingArea={props.waitingArea} updateOrView="update" />
          ) : (
            ''
          )}
          {props.showSupportContactModal == true ? (
            <SupportContactModal waitingArea={props.waitingArea} updateOrView="update" />
          ) : (
            ''
          )}
          {props.showDeleteWAModal == true ? (
            props.waitingArea.rooms && props.waitingArea.rooms.length > 0 ? (
              <WaitingAreaDeleteWAModal waitingArea={props.waitingArea} canDelete={false} dispatch={props.dispatch} />
            ) : (
              <WaitingAreaDeleteWAModal
                waitingArea={props.waitingArea}
                canDelete={true}
                cbAfterDeletion={props.cbAfterDeletion}
                dispatch={props.dispatch}
              />
            )
          ) : (
            ''
          )}
          {(hasOrgEditAccess || hasEditWaitingAreaAccess) && props.showConsultNowSettingModal ? (
            <ConsultNowSettingPage
              waitingArea={props.waitingArea}
              isConsultNowEnabled={props.isConsultNowEnabled}
              updateOrView={'update'}
            />
          ) : (
            ''
          )}
          {(hasOrgEditAccess || hasEditWaitingAreaAccess) && props.showWAAudioSettingModal ? (
            <WAAudioSettingPage
              waitingArea={props.waitingArea}
              isRecordingEnabled={props.WARecordingFeature}
              updateOrView={hasOrgUnitManageUsersAccess && !props.isSystemAdmin ? 'update' : 'view'}
            />
          ) : (
            ''
          )}
          {props.showGCSettingsModal ? <GroupConsultationSettingsPage waitingArea={props.waitingArea} /> : ''}
          <WaitingAreaGeneralDetailPage
            waitingAreaForm={props.waitingAreaForm}
            waitingArea={props.waitingArea}
            updateOrInsert="update"
          />
          <WaitingAreaOperatingHoursPage
            waitingAreaForm={props.waitingAreaForm}
            waitingArea={props.waitingArea}
            updateOrView="update"
          />
          <WaitingAreaLocalAccessHoursPage waitingArea={props.waitingArea} updateOrView="update" />
          <SuspendWAPage waitingArea={props.waitingArea} />
          <WaitingAreaLogoPauseImage waitingArea={props.waitingArea} readOnly={false} />
        </div>
      );
    }
    if (!hasEditWaitingAreaAccess && hasViewWaitingAreaAccess) {
      viewableGCModals = props.showGCSettingsModal ? (
        <GroupConsultationSettingsPage waitingArea={props.waitingArea} />
      ) : (
        ''
      );
    }
  }
  return (
    <>
      {modals}
      {viewableGCModals}
    </>
  );
};

function mapStateToProps(state) {
  let selectedWaitingArea = state.waitingAreaReducer.cleanWaitingArea;
  if (!!(state.waitingAreaReducer.selectedWaitingArea && state.waitingAreaReducer.selectedWaitingArea.id)) {
    selectedWaitingArea = state.waitingAreaReducer.waitingAreas.find(
      (wa) => wa.id === state.waitingAreaReducer.selectedWaitingArea.id
    );
  }
  const waitingArea = objectAssign({}, state.waitingAreaReducer.cleanWaitingArea, selectedWaitingArea);
  return {
    waitingAreaForm: state.waitingAreaReducer.waitingAreaForm,
    showConsultNowSettingModal: state.modalReducer.showConsultNowSettingModal,
    showCreateWaitingAreaModal: state.modalReducer.showCreateWaitingAreaModal,
    isConsultNowEnabled: waitingArea.isConsultNowEnabled,
    showBeforeCallsModal: state.modalReducer.showBeforeCallsModal,
    showBeforeCallsImportantInfoModal: state.modalReducer.showBeforeCallsImportantInfoModal,
    showCallerEntryModal: state.modalReducer.showCallerEntryModal,
    showDuringCallsModal: state.modalReducer.showDuringCallsModal,
    showAfterCallsModal: state.modalReducer.showAfterCallsModal,
    showSupportContactModal: state.modalReducer.showSupportContactModal,
    showInfoForCallersModal: state.modalReducer.showInfoForCallersModal,
    showDeleteWAModal: state.modalReducer.showDeleteWAModal,
    showWAShareLinkMessageModal: state.modalReducer.showWAShareLinkMessageModal,
    showWAAudioSettingModal: state.modalReducer.showWAAudioSettingModal,
    WARecordingFeature: state.waitingAreaReducer.WARecordingFeature,
    isSystemAdmin: state.usersReducer.userProfile && state.usersReducer.userProfile.isSystemAdmin,
    showGCSettingsModal: state.modalReducer.showGCSettingsModal,
  };
}
export default connect(mapStateToProps, null)(WaitingAreasAdminModals);
